<div class="container">
    <mat-card class="contact-feeback-card">
        <mat-card-content>
            {{ feedbackText }}
        </mat-card-content>
      </mat-card>
    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
        
        <label class="label">Name *</label>
        <input type="text" name="name" id="name" formControlName="name" class="input-field">
        <div class='error-text' *ngIf="showErrorText('name')">This field is mandatory.</div>
        
        <label class="label">Email Id *</label>
        <input type="text" name="email" id="email" formControlName="email" class="input-field">
        <div class='error-text' *ngIf="showErrorText('email')">This field is mandatory.</div>
        
        <label class="label" >Comments *</label>
        <textarea name="" id="" cols="50" rows="10" formControlName="message"></textarea>
        <div class='error-text' *ngIf="showErrorText('message')">This field is mandatory.</div>

        <br>
        <button class="button" [disabled]="isSubmitDisabled()">Submit</button>
    </form>
</div>
